/*
accordion.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/hdx/components/hdx-bootstrap/js/hdx-bootstrap/accordion',[
    'jquery',
    'bootstrap/collapse'
], function ($) {
    'use strict';

    function togglePanelToggle(event) {
        var $target = $(event.target);
        var $toggle = $target.parent('.panel').find('.panel-toggle');
        if (event.type === 'show' || (event.type === 'load' && $target.hasClass('in'))) {
            $toggle.addClass('in');
        } else if (event.type === 'hide') {
            $toggle.removeClass('in');
        }
    }

    // Make accordion carets animate and initialize them on page load.
    $('.panel-group .collapse')
        .on('show hide load', togglePanelToggle)
        .trigger('load');

    return togglePanelToggle;
});

